<template>
  <ExamScheduleTable 
    :class-id="classId"
    :class-name="className"
    v-can="'exam_schedules.display'"
  />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import ExamScheduleTable from '@/components/features/schedules/ExamScheduleTable.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const route = useRoute();
const store = useStore();
const toast = useToast();

const classId = route.params.classId;
const className = ref('');

const fetchClassData = async () => {
  try {
    const response = await store.dispatch('classes/fetchClass', classId);
    className.value = response.data?.name || response.name || 'صف غير معروف';
  } catch (error) {
    toast.error(t('classes.loadError'));
    className.value = 'صف غير معروف';
  }
};


onMounted(() => {
  fetchClassData();
});
</script>